<template>
  <div class="container" v-if="evaluationsDataLoaded && applicationDataLoaded">
    <div class="level">
      <div class="level-left">
        <div class="level-item">
          <h4 class="title is-4">
            {{ application.organization.name }}
            <span
              class="tag is-primary"
              v-if="application.isEvaluatedByUser"
              style="margin: 0 10px"
            >
              Completed
            </span>
          </h4>
        </div>
      </div>
      <div class="level-right">
        <div class="level-item" v-if="user.is_staff">
          <button class="button is-primary" @click="sendEmailForApplication(application)">
            Send Group Email
          </button>
        </div>

       <div class="level-item">
         <button class="button" @click="copyMagicLinkToClipboard()">
           Copy Magic Link
         </button>
       </div>

        <div class="level-item">
          <router-link
            :to="{
              name: 'StaffApplicationReviewDetailEdit',
              params: { applicationId: application.id },
            }"
          >
            <div class="level-item">
                <button class="button">
                  Edit Proposal
                </button>
            </div>
          </router-link>
        </div>
        <div class="level-item">
          <button
            class="button"
            @click="showProposal = !showProposal"
            :class="{ 'is-primary': showProposal }"
          >
            {{ showProposal ? 'Hide Proposal' : 'Show Proposal' }}
          </button>
        </div>
        <div class="level-item">
          <button
            class="button"
            @click="showEvaluation = !showEvaluation"
            :class="{ 'is-primary': showEvaluation }"
          >
            {{ showEvaluation ? 'Hide Evaluation' : 'Show Evaluation' }}
          </button>
        </div>
        <div class="level-item"  v-if="user.is_staff">
          <button class="button is-primary" 
           @click="toViewEvaluationVersion(application.id)">
            Evaluator Version
          </button>
        </div>
        <div class="level-item">
          <button
            class="button is-primary is-outlined"
            v-if="application.reportRef && application.reportRef.isPublished"
            @click="toViewReport(application.id)"
          >
            View Report
          </button>
          <button class="button is-primary" v-else @click="toGenerateReport(application.id)">
            Prepare Report
          </button>

        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column" v-if="!showEvaluation && !showProposal">
        <div class="content">
          Everything is hidden! Click one of the buttons above to un-hide either the proposal or the
          evaluation.
        </div>
      </div>
      <div class="column" v-if="showProposal">
        <h4 class="title is-4">Their Submitted Proposal</h4>
        <div class="content">
          <table class="table is-bordered propTable">
            <tbody>
              <tr>
                <th class="app-summary-label">Organization Name</th>
                <td class="has-text-centered">
                  {{ application.organization ? application.organization.name : '' }}
                </td>
              </tr>
              <tr>
                <th>Organization Type</th>
                <td class="has-text-centered">{{ application.questionOrganizationType }}</td>
              </tr>
              <tr>
                <th>Organization Website</th>
                <td class="has-text-centered">{{ application.questionOrganizationWebsite }}</td>
              </tr>
              <tr>
                <th>Applicant Name</th>
                <td class="has-text-centered">{{ getSubmitterName() }}</td>
              </tr>
              <tr>
                <th>Applicant Emails</th>
                <td class="has-text-centered">{{ getSubmitterEmails() }}</td>
              </tr>
              <tr>
                <th>Project Name</th>
                <td class="has-text-centered">{{ application.projectName }}</td>
              </tr>
              <tr>
                <th>Organization Submitted To</th>
                <td class="has-text-centered">{{ application.organizationSubmittedTo }}</td>
              </tr>
            </tbody>
          </table>
          <span v-if="application.questionTellUsAboutYourOrganization.length > 0" >
          <h5 class="title is-5">Tell us about your organization</h5>
          <p class="content">{{ application.questionTellUsAboutYourOrganization }}</p>
          </span>
          
          <br />
          <span v-if="application.questionWhichTypeOfFunding.length > 0" >
          <h5 class="title is-5">Which type of funding do you think is the best fit for the appeal made in this proposal?</h5>
          <p class="content">{{ application.questionWhichTypeOfFunding }}</p>
          </span>
          
          <br />
          <span v-if="application.questionTellUsAboutProposal.length > 0" >
          <h5 class="title is-5">Tell us about your proposal</h5>
          <p  class="content">{{ application.questionTellUsAboutProposal }}</p>
          </span>
          <br />
          <span v-if="application.questionAboutProposalAuthor">
            <h5 class="title is-5">Tell us about the proposal author</h5>
            <p class="content">{{ application.questionAboutProposalAuthor }}</p>
          </span>
          <br />
          <span v-if="application.questionChangesToApproach.length > 0" >
          <h5 class="title is-5">Have there been major changes to the way you approach funders and/or write proposals since your last submission?</h5>
          <p class="content">{{ application.questionChangesToApproach }}</p>
          </span>
         
          <br />
          <span v-if="application.questionWhereElseHaveYouSubmitted.length > 0" >
          <h5 class="title is-5">Where else have you submitted this? Or where do you plan to submit?</h5>
          <p class="content">{{ application.questionWhereElseHaveYouSubmitted }}</p>
          </span>
         
          <br />
          <span v-if="application.questionWhyRejected.length > 0" >
          <h5 class="title is-5">If they said no, why do you think it was rejected?</h5>
          <p class="content">{{ application.questionWhyRejected }}</p>
          </span>
          <br />
          <span v-if="application.questionAdditionalComments.length > 0" >
          <h5 class="title is-5">Any additional comments?</h5>
          <p class="content">{{ application.questionAdditionalComments }}</p>
          </span>
          <br />
          <span v-if="application.questionKujalinkProfile">
            <h5 class="title is-5">What is your KujaLink profile?</h5>
            <p class="content">
              <a :href="application.questionKujalinkProfile" target="_blank">
                {{ application.questionKujalinkProfile }}
              </a>
            </p>
          </span>
          <br />
          <h5 class="title is-5">Provide us a link to your application</h5>
          <a v-if="application.proposal" :href="application.proposal" target="_blank">
            <button class="button">Download Proposal</button>
          </a>
          <a v-if="application.proposalLink" :href="application.proposalLink" target="_blank">
            <button class="button">Link to Proposal</button>
          </a>
        </div>
      </div>
      <div class="column" v-if="showEvaluation">
        <h5 class="title is-5">Completed Evaluations</h5>
        <div class="content" v-if="evaluations.length === 0">
          <em>There are no evaluations yet for this application.</em>
        </div>
        <div
          class="box"
          v-for="evaluation in evaluations"
          v-if="evaluation.isCompleted"
          :key="evaluation.id"
        >
          <div class="level">
            <div class="level-left">
              <div class="level-item">
                <div>
                  <strong>{{ evaluation.evaluator.fullName }}</strong
                  ><br />
                  {{ evaluation.evaluator.email }}<br />
                </div>
              </div>
            </div>
            <div class="level-right">
              <button class="button" @click="evaluation.isHidden = !evaluation.isHidden">
                {{ evaluation.isHidden ? 'Show Evaluation' : 'Hide Evaluation' }}
              </button>
            </div>
          </div>

          <div
            v-for="(section, index) in evaluation.sections"
            :key="index"
            v-if="!evaluation.isHidden"
          >
            <div
              v-for="response in getOrderedResponsesBySection(section, evaluation.responses)"
              :key="response.id"
            >
              <hr />
              <div class="content">
                <strong
                  >{{ response.questionRef.questionText }} ({{
                    response.questionRef.questionType | toTitle
                  }})</strong
                >
                <ul>
                  <li class="break-pars">{{ response.response }}</li>
                </ul>
              </div>
            </div>
          </div>

          <div class="content">
            <strong>Follow-Ups:</strong>
            <nav class="navbar is-light">
              <div class="container">
                <div class="buttons">
                  <button
                    class="button is-primary is-outlined"
                    @click="toggleCommitmentModal(INTRODUCTION_OFFER, evaluation.id)"
                  >
                    Introduction Offer
                  </button>
                  <button
                    class="button is-primary is-outlined"
                    @click="toggleCommitmentModal(DIRECT_CONVERSATION, evaluation.id)"
                  >
                    Direct Conversation
                  </button>
                  <button
                    class="button is-primary is-outlined"
                    @click="toggleCommitmentModal(RESOURCE_SUGGESTION, evaluation.id)"
                  >
                    Resource Suggestion
                  </button>
                </div>
              </div>
            </nav>
            <div
              style="margin: 5px 0"
              v-for="commitment in evaluation.commitments"
              :key="commitment.id"
            >
              <StaffCommitmentSummary :commitment="commitment" />
            </div>
          </div>

        </div>
        <h5 class="title is-5">Incomplete Evaluations</h5>
        <div class="content" v-if="evaluations.length === 0">
          <em>There are no evaluations yet for this application.</em>
        </div>
        <div
          class="box"
          v-for="evaluation in evaluations"
          v-if="!evaluation.isCompleted && !evaluation.isEmpty"
          :key="evaluation.id"
        >
          <div class="level">
            <div class="level-left">
              <div class="level-item">
                <div>
                  <strong>{{ evaluation.evaluator.fullName }}</strong
                  ><br />
                  {{ evaluation.evaluator.email }}<br />
                </div>
              </div>
            </div>
            <div class="level-right">
              <button class="button" @click="evaluation.isHidden = !evaluation.isHidden">
                {{ evaluation.isHidden ? 'Show Evaluation' : 'Hide Evaluation' }}
              </button>
            </div>
          </div>
          <div
            v-for="response in evaluation.responses"
            v-if="!evaluation.isHidden"
            :key="response.id"
          >
            <hr />
            <div class="content">
              <strong
                >{{ response.questionRef.questionText }} ({{
                  response.questionRef.questionType | toTitle
                }})</strong
              >
              <ul>
                <li>{{ response.response }}</li>
              </ul>
            </div>
          </div>
          <div class="content">
            <strong>Follow-Ups:</strong>
            <nav class="navbar is-light">
              <div class="container">
                <div class="buttons">
                  <button
                    class="button is-primary is-outlined"
                    @click="toggleCommitmentModal(INTRODUCTION_OFFER, evaluation.id)"
                  >
                    Introduction Offer
                  </button>
                  <button
                    class="button is-primary is-outlined"
                    @click="toggleCommitmentModal(DIRECT_CONVERSATION, evaluation.id)"
                  >
                    Direct Conversation
                  </button>
                  <button
                    class="button is-primary is-outlined"
                    @click="toggleCommitmentModal(RESOURCE_SUGGESTION, evaluation.id)"
                  >
                    Resource Suggestion
                  </button>
                </div>
              </div>
            </nav>
            <div
              style="margin: 5px 0"
              v-for="commitment in evaluation.commitments"
              :key="commitment.id"
            >
              <StaffCommitmentSummary :commitment="commitment" />
            </div>
          </div>
        </div>
        <h5 class="title is-5">Empty Evaluations</h5>
        <div
          class="box"
          v-for="evaluation in evaluations"
          v-if="!evaluation.isCompleted && evaluation.isEmpty"
          :key="evaluation.id"
        >
          <div class="level">
            <div class="level-left">
              <div class="level-item">
                <div>
                  <strong>{{ evaluation.evaluator.fullName }}</strong
                  ><br />
                  {{ evaluation.evaluator.email }}<br />
                </div>
              </div>
            </div>
            <div class="level-right">
              <button class="button" @click="evaluation.isHidden = !evaluation.isHidden">
                {{ evaluation.isHidden ? 'Show Evaluation' : 'Hide Evaluation' }}
              </button>
            </div>
          </div>
          <div
            v-for="response in evaluation.responses"
            v-if="!evaluation.isHidden"
            :key="response.id"
          >
            <hr />
            <div class="content">
              <strong
                >{{ response.questionRef.questionText }} ({{
                  response.questionRef.questionType | toTitle
                }})</strong
              >
              <ul>
                <li>{{ response.response }}</li>
              </ul>
            </div>
          </div>
          <div class="content">
            <strong>Follow-Ups:</strong>
            <nav class="navbar is-light">
              <div class="container">
                <div class="buttons">
                  <button
                    class="button is-primary is-outlined"
                    @click="toggleCommitmentModal(INTRODUCTION_OFFER, evaluation.id)"
                  >
                    Introduction Offer
                  </button>
                  <button
                    class="button is-primary is-outlined"
                    @click="toggleCommitmentModal(DIRECT_CONVERSATION, evaluation.id)"
                  >
                    Direct Conversation
                  </button>
                  <button
                    class="button is-primary is-outlined"
                    @click="toggleCommitmentModal(RESOURCE_SUGGESTION, evaluation.id)"
                  >
                    Resource Suggestion
                  </button>
                </div>
              </div>
            </nav>
            <div
              style="margin: 5px 0"
              v-for="commitment in evaluation.commitments"
              :key="commitment.id"
            >
              <StaffCommitmentSummary :commitment="commitment" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal is-active" v-if="showCommitmentModal">
      <div class="modal-background"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">Make a Follow-Up commitment!</p>
          <button class="delete" @click="toggleCommitmentModal"></button>
        </header>
        <section class="modal-card-body">
          <div class="field">
            <label class="label">How can you help?</label>
            <div class="control">
              <textarea class="textarea" v-model="newCommitment.description"></textarea>
            </div>
          </div>
        </section>
        <footer class="modal-card-foot">
          <button class="button is-primary" @click="createCommitment()">
            Submit
          </button>
          <button class="button" @click="toggleCommitmentModal">Cancel</button>
        </footer>
      </div>
    </div>
    <BulkEmailSubmittersModal
      v-if="showModal"
      :applications="[application]"
      @close="showModal = !showModal"
      @submit="refreshData()"
    />
  </div>
</template>

<script>
import Commitment from '@/services/commitments/'
import Application from '@/services/applications/'
import copyToClipboard from 'copy-to-clipboard'
import store from '@/vuex/store'
import BulkEmailSubmittersModal from '@/components/emails/BulkEmailSubmittersModal'
import StaffCommitmentSummary from '@/components/StaffCommitmentSummary'

import { mapState } from 'vuex'

export default {
  components: { BulkEmailSubmittersModal, StaffCommitmentSummary },
  filters: {
    toTitle(value) {
      let str = value.toLowerCase().split('_')
      for (var i = 0; i < str.length; i++) {
        str[i] = str[i].charAt(0).toUpperCase() + str[i].slice(1)
      }
      return str.join(' ')
    },
  },
  data() {
    return {
      updatingData: false,
      submissionDataLoaded: false,
      showModal: false,
      submissions: {},
      applicationId: null,
      introModalShown: false,
      evaluationsDataLoaded: false,
      applicationDataLoaded: false,
      application: null,
      evaluations: {},
      showProposal: true,
      showEvaluation: true,
      newCommitment: Commitment.create(),
      showCommitmentModal: false,
      INTRODUCTION_OFFER: Commitment.INTRODUCTION_OFFER,
      DIRECT_CONVERSATION: Commitment.DIRECT_CONVERSATION,
      RESOURCE_SUGGESTION: Commitment.RESOURCE_SUGGESTION,
    }
  },
  computed: {
    ...mapState(['userLoggedInStatus', 'user']),
    canSubmit() {
      if (this.evaluationDataLoaded === false) {
        return false
      }
      return this.evaluation.responses.every(response => response.response)
    },
  },

  created() {
    this.applicationId = this.$route.params.applicationId
    this.refreshData()
  },
  methods: {
    sendEmailForApplication(application) {
      console.log("sendEmailForApplication");
      this.showModal = false;
      console.log(application)
      this.showModal = true
      console.log("sendEmailForApplication-end");
    },
    refreshData() {
      Application.api.get(this.applicationId).then(data => {
        this.application = data
        console.log("this.application1")
        console.log(this.application)
        this.applicationDataLoaded = true
      })
      Application.api.getEvaluations(this.applicationId).then(data => {
        const evaluations = data
        evaluations.forEach(evaluation => {
          evaluation.isHidden = true
        })
        this.evaluations = evaluations
        this.evaluationsDataLoaded = true
      })
    },
    copyMagicLinkToClipboard() {
      //console.log("copyMagicLinkToClipboard");
      const emailURL = `users/${this.application.submitter.id}/get-magic-link/`
      const emailPromise = store.getters.apiClient.get(emailURL)
      emailPromise.then(response => {
        const data = response.data
        copyToClipboard(`${data.magic_link}`)
        this.$Alert.alert({
          type: 'info',
          message: `<p>Copied</p>`,
          timeout: 6000,
        })
      })
    },

    createCommitment() {
      const commitment = this.newCommitment.copy()
      commitment['status'] = 'APPROVED'

      Commitment.api
        .create(commitment)
        .then(response => {
          // Update the UI of the evaluation to show the new commitment
          const evaluationIndex = this.evaluations.map(e => e.id).indexOf(commitment['evaluation'])
          if (evaluationIndex > -1) {
            const evaluation = this.evaluations[evaluationIndex]
            evaluation.commitments.push(response)
            this.evaluations.splice(evaluationIndex, 1, evaluation)
          }
          this.toggleCommitmentModal()
        })
        .catch(err => {
          this.$Alert.alert({
            type: 'error',
            message: `<p>Error creating follow-up</p>`,
            timeout: 6000,
          })
        })
    },
    toggleCommitmentModal(type = '', evaluationId = '') {
      this.showCommitmentModal = !this.showCommitmentModal
      // Update commitment in state when the modal is toggled
      this.newCommitment = Commitment.create({ name: type, evaluation: evaluationId })
    },
    toGenerateReport(id) {
      this.$router.push({ name: 'StaffReportGeneration', params: { applicationId: id } })
    },
    toViewReport(id) {
      const url = `/application-reports/${id}/`
      window.open(url, '_blank')
    },
    toViewEvaluationVersion(id) {
      const url = `/applications/assigned/${id}/`
      window.open(url, '_parent')
    },
    getOrderedResponsesBySection(section, responses) {
      // Return all responses for a particular section in order
      const orderedResponses = responses.filter(r => r.questionRef.section === section.id)
      orderedResponses.sort((a, b) => a.questionRef.order - b.questionRef.order)
      return orderedResponses
    },
    getSubmitterName() {
      if (this.application.submitter != null) {
        return this.application.submitter.fullName
      }
      return ''
    },
    getSubmitterEmails() {
      if (this.application.submitter != null) {
        return this.application.submitter.oldNotes
      }
      return ''
    },
  },
}
</script>

<style scoped>
.tag {
  margin: 0 2px;
}
.fa {
  margin: 0 2px;
}

.navbar {
  margin-bottom: 1.5rem;
}

.navbar .button {
  width: 11rem;
}

.navbar .buttons {
  width: 100%;
  justify-content: center;
}

.propTable {
  word-break: break-word;
}
.app-summary-label {
  min-width: 130px;
}
.break-pars {
  white-space: pre-wrap;
}
</style>
